import React, { useState } from "react";
import {
  mentalAbnormalOptions,
  mentalStatusOptions,
} from "../../../../Options/systemicExamOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";
import SelectWithOtherInput from "../../../../../../blocks/FormItems/SelectWithOtherInput";

const MentalStatus = ({ form }) => {
  const [refresh, setRefresh] = useState(false);

  return (
    <>
      <DeselectableRadioGroup
        label={"Mental Status"}
        name={"mental_status"}
        options={mentalStatusOptions}
        form={form}
        setRefresh={setRefresh}
      />
      {form.getFieldValue("mental_status") === "abnormal" && (
        <SelectWithOtherInput
          name={"mental_status_details"}
          form={form}
          options={mentalAbnormalOptions}
          selectProps={{
            onChange: () => {
              setRefresh((prev) => !prev);
            },
          }}
        />
      )}
    </>
  );
};

export default MentalStatus;
